"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ApiDomain;
(function (ApiDomain) {
    ApiDomain["TEST"] = "http://wwwexpediacom.locate-me-service.us-west-2.test.expedia.com";
    ApiDomain["DEV"] = "http://wwwexpediacom.sandbox.dev.sb.karmalab.net:8888";
})(ApiDomain = exports.ApiDomain || (exports.ApiDomain = {}));
//# sourceMappingURL=api-domain.js.map